
import objectFitImages from 'object-fit-images';
import domready from '../utils/domready.js';
	domready(function() {
		objectFitImages();
	});
